import React from 'react';
import PropTypes from 'prop-types';
import { Wrapper, Button, Menu, MenuItem } from 'react-aria-menubutton';
import classnames from 'classnames';
import DOMPurify from "dompurify";

import './MultiSelectInput.scss';
import CheckCircleIcon from '../../icons/check-circle-icon/CheckCircleIcon';

const MultiSelectInput = ({
  dataList,
  extraSpanClass,
  handleSelection,
  selectedItem,
  promptText,
  wrapperClass,
  extraClass,
  isDisabled,
  label,
  name,
  id,
  labelTooltip,
  removeFilterAction,
  updatedId,
  showDynamicFilter,
  isCreateQueue,
  removeTopMargin,
  hideLabel,
  customeElementLabel,
  reportName,
  filterErrorMsg,
}) => {
  function getHtmlizedItem(item) {
    return (
      <span
        dangerouslySetInnerHTML={{ __html: item }} // eslint-disable-line react/no-danger
      />
    );
  }

  function getCommSeparateSpan(items) {
    const selectedItems = items.map((obj) => { return obj.text; }).join(', ');
    return (
      <span
        dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(selectedItems) }} // eslint-disable-line react/no-danger
      />
    );
  }
  let acquirerCode = JSON.parse(sessionStorage.getItem("state")).auth.user.acquirerCode;
const classNames = classnames(`select-menu ${wrapperClass}`, `select-menu ${wrapperClass}_` + acquirerCode, {
  [`${extraClass}`]: extraClass
});

const menuTriggerClasses = classnames('dropdown-menu-trigger', 'dropdown-menu-trigger_' + acquirerCode, {
  'is-disabled': isDisabled,
  'disabled-true': reportName == "MRE" ? "" : isDisabled
});

  const menuItemElements = dataList.map((item) => {
    const isSelected = selectedItem && selectedItem.find((map) => { return map.value === item.value; });

    const itemClass = classnames('select-menu-option', {
      'is-selected': isSelected,
    });
    return (
      <li className="select-menu-options-wrapper" key={item.value} >
        <MenuItem className={itemClass} value={item.value} text={item.text} data-name={name}>
          {item.text}
          {isSelected &&
            <span className="select-menu-option-check">

              <CheckCircleIcon name={name} />
            </span>
          }
        </MenuItem>
      </li>
    );
  });

  const labelContent = (<span className="label-style" style={{ opacity: hideLabel ? "0" : "1" }}>
    <label htmlFor={`${label}`} className="field-label"><span className={extraSpanClass}>{customeElementLabel != null ? customeElementLabel : label}</span></label>
    {labelTooltip}
    {showDynamicFilter && <div role='button' className="clear-filters" style={{ cursor: "pointer", marginTop: "-3px", float: "left" }} onClick={() => removeFilterAction(updatedId)}>
      <span>&nbsp;&nbsp;<u>remove</u></span>
    </div>}
    {reportName === 'MRE' && filterErrorMsg  && <span style={{ "color": "red", fontFamily: 'Roboto', fontStyle: "normal", fontWeight: 400, fontSize: "12px", marginLeft: "8px" }}>{filterErrorMsg}</span>}
  </span>);

  const selectFieldClass = (removeTopMargin !== null && removeTopMargin !== undefined && removeTopMargin === true) ? "select-field-cq" : (isCreateQueue ? "select-field-cq" : reportName == "Unresolved RTI" ? "select-field-input-un-rti" : "select-field-input");
  return (
    <div className={`${selectFieldClass}`} >
      <Wrapper
        className={classNames}
        onSelection={handleSelection}
        closeOnSelection={false}
      >
        {label !== ''
          ? labelContent
          : ''
        }

        <Button
          id={`${id}`}
          className={menuTriggerClasses}
          disabled={isDisabled}
        >
          <div className="ellipsis" style={{ cursor: isDisabled ? "not-allowed" : "" }}>
            {selectedItem && selectedItem.length
              ? getCommSeparateSpan(selectedItem)
              : getHtmlizedItem(promptText)}
          </div>
        </Button>

        <Menu>
          {(
            <ul className="select-menu-options">{menuItemElements}</ul>
          )}
        </Menu>
      </Wrapper>
    </div>
  );
};

MultiSelectInput.propTypes = {
  dataList: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      text: PropTypes.string,
    }),
  ).isRequired,
  handleSelection: PropTypes.func.isRequired,
  promptText: PropTypes.string,
  selectedItem: PropTypes.arrayOf(PropTypes.shape({
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    text: PropTypes.string,
  })),
  wrapperClass: PropTypes.string.isRequired,
  extraClass: PropTypes.string,
  isDisabled: PropTypes.bool,
  label: PropTypes.string,
  name: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]).isRequired,
  id: PropTypes.string,
  labelTooltip: PropTypes.object,
  isCreateQueue: PropTypes.bool,
};

MultiSelectInput.defaultProps = {
  promptText: 'select',
  selectedItem: [],
  dataList: [],
  extraClass: '',
  isDisabled: false,
  label: '',
  name: 0,
  id: '',
  labelTooltip: null,
  isCreateQueue: false,
};

export function findItem(list, selectedValue) {
  return list.find((item) => item.value === selectedValue);
}

export default MultiSelectInput;
